import { AppService } from "app/services/app.service";


export abstract class AbContaPublica extends AppService {

  abstract getTipoContaLogadaPublica();
  abstract getTipoContaPublicaById(id: number);
}